<div class="page-container">
  <div class="page-header">
    <div class="page-header-left">
      <h2 class="page-title">Email Templates</h2>
      <p class="page-subtitle">Reusable messages for taxpayer correspondence (e-mail + portal inbox).</p>
    </div>
    <button mat-flat-button color="primary" [routerLink]="['/app/correspondence/templates/new']">
      <mat-icon>add</mat-icon>
      New Template
    </button>
  </div>

  <!-- Filter Bar -->
  <div class="filter-bar">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search templates</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [(ngModel)]="searchQuery" (ngModelChange)="onSearch()" placeholder="Name or subject">
      @if (searchQuery) {
        <button matSuffix mat-icon-button (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-status">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="filterStatus" (ngModelChange)="onFilter()">
        <mat-option value="">All</mat-option>
        @for (s of statuses; track s) {
          <mat-option [value]="s">{{ s | titlecase }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Table -->
  <div class="mat-elevation-z2 table-wrapper">
    <table mat-table [dataSource]="dataSource" matSort aria-label="Email templates">

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let row">
          <div class="template-name-cell">
            <mat-icon class="template-icon">description</mat-icon>
            <span class="template-name">{{ row.name }}</span>
          </div>
        </td>
      </ng-container>

      <!-- Subject Column -->
      <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Subject</th>
        <td mat-cell *matCellDef="let row">
          <span class="subject-text">{{ row.subject }}</span>
        </td>
      </ng-container>


      <!-- Last Modified Column -->
      <ng-container matColumnDef="lastModified">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Modified</th>
        <td mat-cell *matCellDef="let row">{{ row.lastModified | date:'MM/dd/yyyy' }}</td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let row">
          <span class="status-badge" [ngClass]="getStatusClass(row.active)">
            {{ row.active ? 'Active' : 'Inactive' }}
          </span>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <div class="actions-cell">
            <button mat-icon-button title="View / Edit template" [routerLink]="['/app/correspondence/templates', row.id]">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
          <mat-icon>description</mat-icon>
          <span>No templates found.</span>
        </td>
      </tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>
